import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { SocialMediaCoreDomainNameStringAssets } from "../../../../../assets/stringAssets";

/**
 * @function referenceIsForALInkedInPost Returns whether the socialMediaPostRawReference is related to a LinkedIn post
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export const referenceIsForALInkedInPost: (socialMediaPostRawReference: string) => boolean = (socialMediaPostRawReference: string) => {
  // return value (defaulted to 'false') indicating whether the socialMediaPostRawReference matches a known regular expression
  let foundMatchForRawReference: boolean = false;

  // as a quick check, determine whether this social media's core domain name is found withing the raw reference
  if (socialMediaPostRawReference.toLowerCase().search(SocialMediaCoreDomainNameStringAssets.LinkedIn.toLowerCase()) !== -1) {

    // test for each type of raw reference for this social media type until a match is found or the list of social media types has been exhausted
    if (!foundMatchForRawReference) {
      foundMatchForRawReference = RegularExpressions.LinkedInEmbedUrl.test(socialMediaPostRawReference);
    }

    if (!foundMatchForRawReference) {
      foundMatchForRawReference = RegularExpressions.LinkedInIFrameWithFullSpecs.test(socialMediaPostRawReference);
    }
  }

  // return the result of testing the given socialMediaPostRawReference against the regex pattern(s)
  return foundMatchForRawReference;
}
